module.exports = "/pages/business/foodslabo/service_icon_3.png";